import { useState, useEffect, useRef } from 'react';
import { MapPin } from 'lucide-react';
import { searchLocations } from '../services/api';

export default function LocationAutocomplete({ value, onChange, placeholder, className, style, inputClassName, inputStyle }) {
  const [query, setQuery] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef();
  const debounceRef = useRef();

  useEffect(() => {
    setQuery(value || '');
  }, [value]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInput = (val) => {
    setQuery(val);
    onChange(val);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (val.length < 1) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    setLoading(true);
    debounceRef.current = setTimeout(() => {
      searchLocations(val)
        .then(res => {
          setSuggestions(res.data);
          setShowDropdown(res.data.length > 0);
          setLoading(false);
        })
        .catch(() => { setLoading(false); });
    }, 200);
  };

  const handleSelect = (loc) => {
    setQuery(loc.name);
    onChange(loc.name);
    setShowDropdown(false);
  };

  return (
    <div ref={wrapperRef} className={`location-autocomplete ${className || ''}`} style={{ position: 'relative', ...style }}>
      <input
        type="text"
        value={query}
        onChange={(e) => handleInput(e.target.value)}
        onFocus={() => { if (suggestions.length > 0) setShowDropdown(true); }}
        placeholder={placeholder || 'Type a location...'}
        className={inputClassName || ''}
        style={inputStyle || {}}
        autoComplete="off"
      />
      {showDropdown && (
        <div className="location-dropdown">
          {loading ? (
            <div className="location-dropdown-item" style={{ color: '#94a3b8' }}>Searching...</div>
          ) : (
            suggestions.map(loc => (
              <div
                key={loc.id}
                className="location-dropdown-item"
                onClick={() => handleSelect(loc)}
              >
                <MapPin size={14} color="#94a3b8" />
                <span><strong>{loc.name}</strong>{loc.state ? `, ${loc.state}` : ''}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
